// Puente hacia los métodos nativos startPasskeyRegistration/startPasskeyLogin
// que expone MainActivity.kt (WebAppInterface) en la app Android empaquetada.
// El WebView embebido de esa app no implementa navigator.credentials para
// public-key, así que ahí el registro/login de passkeys se resuelve con el
// Credential Manager nativo en vez de @simplewebauthn/browser.

export function isNativePasskeyBridgeAvailable() {
  return (
    typeof window !== 'undefined' &&
    typeof window.Android !== 'undefined' &&
    typeof window.Android.startPasskeyRegistration === 'function' &&
    typeof window.Android.startPasskeyLogin === 'function'
  );
}

export function nativeStartPasskeyRegistration(optionsJSON) {
  return new Promise((resolve, reject) => {
    window.onPasskeyRegistrationResult = (result, error) => {
      delete window.onPasskeyRegistrationResult;
      if (error || !result) {
        reject(new Error(error || 'No se pudo registrar la llave de acceso.'));
      } else {
        resolve(result);
      }
    };
    window.Android.startPasskeyRegistration(JSON.stringify(optionsJSON));
  });
}

export function nativeStartPasskeyLogin(optionsJSON) {
  return new Promise((resolve, reject) => {
    window.onPasskeyLoginResult = (result, error) => {
      delete window.onPasskeyLoginResult;
      if (error || !result) {
        reject(new Error(error || 'No se pudo iniciar sesión con la llave de acceso.'));
      } else {
        resolve(result);
      }
    };
    window.Android.startPasskeyLogin(JSON.stringify(optionsJSON));
  });
}
